import { DefaultButton, PrimaryButton, DirectionalHint, TooltipDelay } from "@fluentui/react";
import React, { useState, useContext, useEffect } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import {isMobile} from "react-device-detect";
import { downloadPdfReport } from "../../../../service/StudyReportService";
import SearchableDropdown from "../../../IssuesAndTroubleshooting/SearchDropdown";
import { dropdownStyles } from "../../helper/initialData";
import DownloadOptions from "./DownloadOptions";
import { Stack, Dropdown } from "@fluentui/react";
import userContext from "../../../../context/users/UserContext";
import { TAB_NAME, USERTYPES, NONXRAYMODALITIES, TOAST_TYPE } from "../../../../constants/Constants";
import CrossIcon from "../../../../components/navbar/nav-icons/CrossIcon";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import QCFailModal from "./QCFailModal";
import QCReasonModal from "./QCReasonModal";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import "../../styles/styles.css";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import UploadFistolugramModal from "./UploadFistolugramModal";
import QCPassConfirmModal from "./QCPassConfirmModal";
import { keyImagesPresent } from "../../../StudyViewer/helpers/KeyImageUtility";
import { t } from "i18next";
import { getReportTemplatesData } from "../../../../service/StudyReportService";
import { OpenInNewWindowIcon } from "@fluentui/react-icons-mdl2";
import loaderContext from "../../../../context/loader/LoaderContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { stylesForCustomSelect } from "../../../../components/CustomSelect"
import toastContext from "../../../../context/toast/ToastContext";
import MaskButton from "../../../StudyList/components/Mask/MaskButton";
import CopyReport from "../CopyReport/CopyReport";
import ResetReport from "../ResetReport/ResetReport";
import ReportTemplateIndicator from "../ReportTemplateIndictor/ReportTemplateIndicator";
import { isChestXrayOrCtBrainStudy } from "../../../../service/MaskImageService";


const AlertSubmitSection = (props) => {
  const [clearRaiseAlert, setClearRaiseAlert] = useState(null);
  const [showResetReport, setShowResetReport] = useState(false);

  const {
    handlePreviewReport,
    handleSaveReport,
    handleSubmitReport,
    handleQcPass,
    handleQcReturnButtonClick,
    handleRaiseAlertDropdown,
    userActionLoading,
    openQcReasonModal,
    setOpenQcReasonModal,
    openFistolugramUploadModal,
    disableDownload,
    disablePreview,
    disableSave,
    disableSubmit,
    disableQCPass,
    disableQCReturn,
    disableRaiseAlert,
    reset,
    raiseAlertList,
    raiseAlertValue,
    setRaiseAlertValue,
    openQcModal,
    disableQCReason,
    isClientReportExist,
    patientReports,
    disableSubmitUntilQCReasonClick,
    isKeyImagesPresent,
    isTextAnnotationPresent,
    openQCPassConfirmModal,
    studyParentId,
    allowDownloadReport,
    handleMarkAsSuspect,
    disableMarkAsSuspect,
    isChildStudyReportState,
    keyImagePresentStudyList,
    showMsWord,
    handleDownloadDoc,
    activeTab,
    handleDSRRegenerate,
    formatterAgentEnabled,
    formattedReportUsed,
    isExternal,
    reportDoneStatusState,
    reviewerId, reviewStatus,
    firstAgenticLLMReport,
    editorRef,
    handleModelChange, setUserPrompts,
    disableResetReport, setDisableResetReport,
    disableCopyButton, setDisableCopyButton,
    studyDescription
  } = useContext(studyReportContext);

  const extReportRecieved = (props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true) ? false : props.extReportReived;
  const { getThemeColor,themeName } = useContext(themeContext);
  // const { createAnnotationJson } = useContext(AnnotationContext);
  let [showInfo1, setShowInfo1] = useState(false);

  const { roles, username, authenticated, loadByUsername, userId, isActiveData, enableLlmReport} =
    useContext(userContext);

  const { loaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);

  const clearValue = () => {
    // console.log("test");
  };

  const updatedStylesDisable = {
    root: {
      // background:'#404040',
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      padding: 0,
    },
  };

  const updatedStylesEnable = {
    root: {
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  
  const updatedStylesEnableMSWord = {
    root: {
      height: "28px",
      width: "90px",
      // left: "-5px"
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingSubmit = {
    root: {
      height: "28px",
      width: "80px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingQCPass = {
    root: {
      height: "28px",
      width: "85px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const iconButtonStyles = {
    root: {
      height: "28px",
      minWidth: "40px",
      width: "40px",
      padding: 0,
    },
    icon: {
      fontSize: "16px",
    },
  };


  const checkForSaveButton = ()=>{
   
     return !disableSave && !isChildStudyReportState && activeTab !== 3; 
    
  }

  const checkForSubmitButton = (getThemeColor) => {
    return !disableSubmit && !isChildStudyReportState && activeTab !== 3;
  }


  const getRaiseAlertLabel = (value) => {
      let data = raiseAlertList;
      if(data != null && data != undefined && data?.length > 0){
        const result = data.find(item => item.value === value);
        if (result) {
          return result?.label
        }
        return value;
      }else{
        return null;
      }
  }

  useEffect(() => {
    const elements = document.getElementsByClassName("react-select__input-container");
  
    if (elements.length > 0 && window.location.href.includes("studylist")) {
      // Convert the HTMLCollection to an array and set the style for each element
      Array.from(elements).forEach(element => {
        element.style.color = getThemeColor("primary-color");
      });
    }
  },[raiseAlertValue,themeName])

  const checkForPeerReviewReportDownloadAvailable = () => {
    if(reviewerId != null && reviewStatus != 1){
      return true;
    }
    return false;
  }

  const checkForDownloadAvailable = () => {
    if(reviewerId != null && reviewerId == userId){
      return false;
    }
    return true;
  }

  console.log(props);

  if (isMobile && props.readOnly) {
    return (
      <div className="mobile-download-box-wrapper">
      {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && 
        !disableDownload && 
        !isChildStudyReportState && (
          <div className="mobile-download-buttons">
          <DefaultButton
            text={t("button.download")}
            disabled={disableDownload}
            styles={updatedStylesDisable}
            onClick={() => {
              if (showInfo1) {
                // console.log("False");
                setShowInfo1(false);
              } else {
                // console.log("True");
                setShowInfo1(true);
              }
            }}
          />
        <DownloadOptions
          studyParentId={studyParentId}
          show={showInfo1}
          onClickOutside={() => setShowInfo1(false)}
          modality={props.modality}
          isKeyImagesPresent={
            props.isStudyList
              ? keyImagePresentStudyList
              : keyImagesPresent(props.keyImages)
          }
          isExtReportReceived={extReportRecieved}
          reportOptions={checkForDownloadAvailable()}
          peerReviewReportOptions={checkForPeerReviewReportDownloadAvailable()}
        />
      </div>)}
   
        </div>
    );
  } else {
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        height: "42px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true ? '8px' : '',
        width: "100%",
      }}
    >
      {!isChildStudyReportState && <div className="ms-Grid-row" style={{ width: "100%" }}>
        <div style={{ 
          display: "flex", 
          flexWrap: "wrap", 
          alignItems: "center", 
          gap: "10px", 
          width: "100%" 
        }}>




   
        {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR) ) && !(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) ) && !disableRaiseAlert && (
          <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4 parent-dropdown">
            {/* {raiseAlertValue != undefined && ( */}
              <CreatableSelect
                menuPlacement="auto"
                classNamePrefix="react-select"
                styles={stylesForCustomSelect(getThemeColor)}
                defaultValue={
                  raiseAlertValue != undefined &&
                  raiseAlertValue != null &&
                  raiseAlertValue != ""
                    ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                    : null
                }
                onChange={(ele) => {
                  handleRaiseAlertDropdown(ele);
                }}
                placeholder={t("placeholder.raise-alert")}
                isClearable
                options={raiseAlertList}
              />
            {/* )} */}
          </div>
        )}

            {enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) && (
              <div style={{ display: "flex", alignItems: "center"}} >
                <ReportTemplateIndicator/>
                <ResetReport/>
                <CopyReport/>

              </div>
            )}
           
          
          {/* Right side buttons - starting with Raise Alert, then all action buttons */}
          <div className="bottom-button" style={{ display: "flex", alignItems: "center", flexGrow: 1}}>
            {/* Raise Alert dropdown - moved to beginning of right side group */}
            {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR)) && enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) && !disableRaiseAlert && (
              <div className="form-field" style={{ width: "100%", maxWidth: "150px", marginRight: "3%", fontSize: "14px" }}>
                <CreatableSelect
                  menuPlacement="auto"  
                  classNamePrefix="react-select" 
                  styles={stylesForCustomSelect(getThemeColor)} 
                  defaultValue={
                    raiseAlertValue != undefined &&
                    raiseAlertValue != null &&
                    raiseAlertValue != ""
                      ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                      : null
                  }
                  onChange={(ele) => {
                    handleRaiseAlertDropdown(ele);
                  }}
                  placeholder={t("placeholder.raise-alert")}
                  isClearable
                  options={raiseAlertList}
                />
              </div>
            )}
            
            {activeTab !== 3 && !disableMarkAsSuspect && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.suspect")}
                  onClick={handleMarkAsSuspect} 
                  disabled={disableMarkAsSuspect || !isActiveData}
                  styles={updatedStylesEnable}
                />
              </div> 
            )}
            
            {activeTab !== 3 && !disablePreview && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.preview")}
                  onClick={handlePreviewReport}
                  disabled={disablePreview}
                  styles={updatedStylesDisable}
                />
              </div>
            )}
  
            {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && 
              !disableDownload && !isChildStudyReportState && (
                <div className="download-box-wrapper form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                  <DefaultButton
                    text={t("button.download")}
                    disabled={disableDownload}
                    styles={updatedStylesDisable}
                    onClick={() => {
                      if (showInfo1) {
                        setShowInfo1(false);
                      } else {
                        setShowInfo1(true);
                      }
                    }}
                  />
                  <DownloadOptions
                    studyParentId={studyParentId}
                    show={showInfo1}
                    onClickOutside={() => {
                      setShowInfo1(false);
                    }}
                    modality={props.modality}
                    isKeyImagesPresent={props.isStudyList ? keyImagePresentStudyList : keyImagesPresent(props.keyImages)}
                    isExtReportReceived={extReportRecieved}
                  />
                </div>
              )
            }
            
            {activeTab !== 3 && !(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && showMsWord && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto"}}>
                <DefaultButton 
                  onClick={() => {
                    handleDownloadDoc(studyParentId)
                  }}
                  iconProps={{iconName:"OpenInNewWindow"}}
                  text={`MS-Word`}
                  styles={updatedStylesEnableMSWord}
                  disabled={!isActiveData}
                />
              </div>
            )}
            {checkForSaveButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto"  }}>
                <DefaultButton
                  text={t("button.save")}
                  onClick={() =>
                    handleSaveReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex
                    )
                  }
                  disabled={
                    !isActiveData || (isClientReportExist == true && patientReports.length == 0) || loaderRunning
                  }
                  styles={updatedStylesDisable}
                />
              </div>
            )}
            
            {activeTab !== 3 && !disableQCReason && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <DefaultButton
                  text={t("button.qc-reason")}
                  onClick={() => setOpenQcReasonModal(true)}
                  styles={updatedStylesDisable}
                />
              </div>
            )}
            
            {checkForSubmitButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.submit")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingSubmit : updatedStylesEnable}
                />
              </div>
            )}
            
            {activeTab !== 3 && !disableQCPass && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <DefaultButton
                  text={t("button.qc-pass")}
                  styles={formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingQCPass : updatedStylesDisable}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleQcPass(
                      studyParentId,
                      props.keyImages,
                      props.qcData,
                      props.allTextToolAnnotation
                    )
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}
            
            {activeTab !== 3 && !disableQCReturn && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <DefaultButton
                  text={t("button.qc-return")}
                  styles={updatedStylesDisable}
                  onClick={() =>
                    handleQcReturnButtonClick(studyParentId, props.qcData)
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}
          </div>
        </div>
        
        {openQCPassConfirmModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <QCPassConfirmModal
              keyImages={props.keyImages}
              qcData={props.qcData}
              allTextToolAnnotation={props.allTextToolAnnotation}
            />
          </div>
        )}
        
        {openQcModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <QCFailModal keyImages={props.keyImages} qcData={props.qcData} allTextToolAnnotation={props.allTextToolAnnotation}/>
          </div>
        )}
        
        {openFistolugramUploadModal && studyParentId != null && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <UploadFistolugramModal studyParentId={studyParentId} />
          </div>
        )}
        
        {openQcReasonModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <QCReasonModal
              patientName={props.patientName}
              patientId={props.patientId}
            />
          </div>
        )}
      </div>}
      
      {isChildStudyReportState && 
        <div style={{ width: "100%" }} className="ms-Grid-row viewer-outline-heatmap-text">
          {t("string-literals.prior-study")}
        </div>
      }
  
      {activeTab === 3 && (isExternal || !NONXRAYMODALITIES.includes(props.modality)) && 
        <PrimaryButton
          className="report-button"
          text={t("studyviewer.regenerate-report")}
          styles={updatedStylesEnable}
          onClick={handleDSRRegenerate}
        />
     }
    </div>
  );
}
};
  export default AlertSubmitSection;